import * as React from 'react';
import { EPageTypes, EPlatformTypes, FicheringCall } from '@cian/frontend-newbuilding-call-component';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';

import { trackOpenContacts, trackShowPhone } from './tracking';
import { getGaLabel, getNewbuildingId, getBuilders, getSellers } from '../../selectors/newbuilding';
import { setUserOpenedPhoneInNewobject } from '../../utils/lastHopePopup';
import { useApplicationContext } from '../../utils/withApplicationContext';

const CALL_BUTTON_STYLES = {
  beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" />,
};

export const Call = () => {
  const gaLabel = useSelector(getGaLabel);
  const builders = useSelector(getBuilders);
  const sellers = useSelector(getSellers);
  const newbuildingId = useSelector(getNewbuildingId);

  const onShowPhoneClick = React.useCallback(() => {
    trackShowPhone(gaLabel);
    setUserOpenedPhoneInNewobject(newbuildingId);
  }, [gaLabel, newbuildingId]);

  const { httpApi, logger } = useApplicationContext();

  const pageType = EPageTypes.NewbuildingCard;
  const platformType = EPlatformTypes.WebDesktop;
  const placeType = 'blockFicheringMainScreen';

  return (
    <FicheringCall
      builders={builders}
      sellers={sellers}
      onOpenContactsClick={() => trackOpenContacts(gaLabel)}
      onShowPhoneClick={onShowPhoneClick}
      httpApi={httpApi}
      logger={logger}
      pageType={pageType}
      platformType={platformType}
      placeType={placeType}
      showPhoneStyles={CALL_BUTTON_STYLES}
      openContactsStyles={CALL_BUTTON_STYLES}
    />
  );
};

Call.displayName = 'Call';
